var exports = {
  "Qs": "GiftAcceptModal.module__content___eURfMz",
  "O8": "GiftAcceptModal.module__loadingContent___eURfMz",
  "Nr": "GiftAcceptModal.module__card___eURfMz",
  "$2": "GiftAcceptModal.module__cardGrid___eURfMz",
  "kJ": "GiftAcceptModal.module__iconCircle___eURfMz",
  "SP": "GiftAcceptModal.module__iconCircleActive___eURfMz",
  "PP": "GiftAcceptModal.module__iconCircleInactive___eURfMz",
  "_O": "GiftAcceptModal.module__iconCircleDisabled___eURfMz",
  "Kk": "GiftAcceptModal.module__icon___eURfMz",
  "m5": "GiftAcceptModal.module__iconError___eURfMz",
  "Ux": "GiftAcceptModal.module__cardContent___eURfMz",
  "DD": "GiftAcceptModal.module__title___eURfMz",
  "jn": "GiftAcceptModal.module__titlePrimary___eURfMz",
  "xP": "GiftAcceptModal.module__titleTertiary___eURfMz",
  "S3": "GiftAcceptModal.module__titleDanger___eURfMz",
  "VA": "GiftAcceptModal.module__subtitle___eURfMz",
  "BK": "GiftAcceptModal.module__helpText___eURfMz",
  "AS": "GiftAcceptModal.module__item___eURfMz",
  "UZ": "GiftAcceptModal.module__itemStage___eURfMz",
  "qC": "GiftAcceptModal.module__itemHeading___eURfMz",
  "YG": "GiftAcceptModal.module__itemType___eURfMz",
  "rv": "GiftAcceptModal.module__itemText___eURfMz",
  "vu": "GiftAcceptModal.module__itemOwned___eURfMz",
  "qr": "GiftAcceptModal.module__footer___eURfMz",
};

module.exports = exports;
